import { useEffect } from 'react';

import { HAS_REDIRECTED } from '@cccom/auth/keycloak';
import { APPS } from '@cccom/config/app-config';
import { useEnvironment } from '@cccom/config/env';
import { useSettings } from '@cccom/shared/settings';

/**
 * hook that controls auto redirection when a user:
 * - has access to only one app or has accessed an app before
 * - and has valid roles
 */
function useAutoRedirect() {
  const env = useEnvironment();
  const { appList, lastAccessedApp, hasValidRoles } = useSettings();

  useEffect(() => {
    const hasRedirected = localStorage.getItem(HAS_REDIRECTED);

    if (hasValidRoles && !hasRedirected && appList.length > 0) {
      // redirect user to app if only one app exists
      if (appList.length === 1) {
        const app = appList[0];
        localStorage.setItem(HAS_REDIRECTED, 'true');
        window.location.href = APPS.getUrl(env, app);
      }

      // redirect user to their last accessed app
      else {
        localStorage.setItem(HAS_REDIRECTED, 'true');
        if (lastAccessedApp)
          window.location.href = APPS.getUrl(env, lastAccessedApp);
      }
    }
  }, [appList, env, hasValidRoles, lastAccessedApp]);
}

export default useAutoRedirect;
